import axios from 'axios';
import { Message, DailyMessage } from '../types';
import config from '../config';

const API_BASE_URL = config.api.url;
const BASE_URL = `${API_BASE_URL}/api/messages`;

// Configuration d'axios avec timeout
const axiosInstance = axios.create({
  timeout: config.api.timeout,
});


export const fetchRandomMessage = async (): Promise<Message> => {
  const response = await axiosInstance.get(`${BASE_URL}/random`);
  return response.data;
};

export const fetchDailyMessage = async (): Promise<DailyMessage> => {
  const response = await axiosInstance.get(`${BASE_URL}/daily`);
  return response.data;
};

export const fetchDailyQuotesHistory = async (page: number = 1, limit: number = 10) => {
  const response = await axiosInstance.get(`${BASE_URL}/daily-history`, {
    params: { page, limit }
  });
  return response.data;
};